import { Tag, Flex, Tooltip, Spin } from 'antd';
import { ReactNode, useCallback, useMemo, useState } from 'react';
import { NAME_PATH, useTralitSetting } from '../../hooks/useTralitSetting';
import { LoadingOutlined } from '@ant-design/icons';

interface LabelTagProp {
  fieldKey?: string;
  label: ReactNode;
  value?: string;
  valueSplit?: string;
  maxCount?: number;
  closable?: boolean;
  onClose?: (key, value) => void;
  loading?: boolean;
}

export const LabelTag: React.FC<LabelTagProp> = (props: LabelTagProp) => {
  const { fieldKey, label, value = '', valueSplit = ',', maxCount = 1, closable = false, onClose, loading = false } = props;

  const { fontSize } = useTralitSetting({ namePath: NAME_PATH.PREFERENCE });

  const ellipsis = useCallback((value) => {
    if (value.length > 10) {
      return <Tooltip title={<div style={{ fontSize: fontSize.tag }}>{value}</div>}>{value.slice(0, 10)} ...</Tooltip>;
    }
    return value;
  }, []);

  const valueText = useMemo(() => {
    const values = value.split(valueSplit).map((v) => v.trim());
    if (values.length > maxCount) {
      return `${values.slice(0, maxCount)} ... +${values.length - maxCount}`;
    }
    return ellipsis(value);
  }, [value]);

  const onCloseHandler = (e) => {
    onClose(fieldKey, value);
    e.preventDefault();
  };

  return (
    <Tag closable={closable} onClose={onCloseHandler} style={{ display: 'flex', alignItems: 'center', fontSize: fontSize.tag }}>
      <span>{label}</span>
      {valueText && (
        <span style={{ marginLeft: 3 }}>: {loading ? <Spin indicator={<LoadingOutlined spin />} size="small" /> : valueText}</span>
      )}
    </Tag>
  );
};
